module.exports = __webpack_public_path__ + "img/9788925549033.7f208d60.jpg";